// This is a custom js file for collection tabs at the top of the page created by Dokania. 

function isLikelyValidHandle(handle) {
  // Shopify handles are typically lowercase, numbers, hyphen
  return typeof handle === "string" && /^[a-z0-9-]+$/.test(handle);
}

function showTabError(root, msg) {
  let el = root.querySelector(".collection-tabs__error");
  if (!el) {
    el = document.createElement("div");
    el.className = "collection-tabs__error";
    root.appendChild(el);
  }
  el.textContent = msg;
  el.style.display = "block";
  clearTimeout(showTabError._t);
  showTabError._t = setTimeout(() => (el.style.display = "none"), 4000);
}



(() => {
  const SECTION_ID = "main-collection-product-grid";

  const SELECTORS = {
    tabsRoot: "[data-collection-tabs]",
    filters: "#main-collection-filters",
    grid: "#ProductGridContainer",
    tabBtn: "button[data-handle]"
  };

  const normalizePath = (p) => (p || "").replace(/\/$/, "");

  async function fetchJson(url) {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error(`Tabs config request failed: ${res.status}`);
    return res.json();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function renderTabs(root, tabs, activeHandle) {
    root.innerHTML = tabs
      .map((t) => {
        const isActive = t.handle === activeHandle;
        return `
          <button
            type="button"
            class="collection-tab ${isActive ? "is-active" : ""}"
            data-handle="${escapeHtml(t.handle)}"
            aria-pressed="${isActive ? "true" : "false"}"
          >${escapeHtml(t.label)}</button>
        `;
      })
      .join("");
  }

  function setActiveTab(root, handle) {
    root.querySelectorAll(SELECTORS.tabBtn).forEach((btn) => {
      const isActive = btn.dataset.handle === handle;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function getHandleFromPath(pathname) {
    const match = (pathname || "").match(/^\/collections\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  async function swapCollection(handle, { pushUrl = true } = {}) {
    const url = `/collections/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(SECTION_ID)}`;
    const res = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    if (!res.ok) throw new Error(`Failed to fetch section HTML: ${res.status}`);

    const html = await res.text();
    // If Shopify/Liquid renders an error, don't swap DOM
if (/Liquid error/i.test(html) || /is not paginateable/i.test(html)) {
  throw new Error("Liquid error in fetched collection HTML");
}

    const doc = new DOMParser().parseFromString(html, "text/html");

    const newFilters = doc.querySelector(SELECTORS.filters);
    const newGrid = doc.querySelector(SELECTORS.grid);

    const currentFilters = document.querySelector(SELECTORS.filters);
    const currentGrid = document.querySelector(SELECTORS.grid);

    if (!currentGrid || !newGrid) throw new Error("Could not find #ProductGridContainer to replace.");

    if (currentFilters && newFilters) currentFilters.replaceWith(newFilters);
    currentGrid.replaceWith(newGrid);

    if (pushUrl) {
      window.history.pushState({ handle }, "", `/collections/${handle}`);
    }

    // Nice UX
    const grid = document.querySelector(SELECTORS.grid);
    if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  async function init() {
    const root = document.querySelector(SELECTORS.tabsRoot);
    if (!root) return;

    try {
      const configUrl = root.dataset.configUrl;
      const currentPath = normalizePath(root.dataset.currentPath);
      const currentHandle = root.dataset.currentHandle;

      console.log("[tabs] init", { configUrl, currentPath, currentHandle });

      const config = await fetchJson(configUrl);

      // Exact match or trailing slash match
      const tabs = config[currentPath] || config[`${currentPath}/`];

      if (!tabs || !tabs.length) {
        console.warn("[tabs] No tabs configured for path:", currentPath, "Config keys:", Object.keys(config));
        // DON'T hide silently — show a small hint so you can debug quickly (No tabs configured message for frontend)
        root.innerHTML = `<div style="font-size:12px;opacity:.7;"></div>`;
        return;
      }

      renderTabs(root, tabs, currentHandle);

      root.addEventListener("click", async (e) => {
        const btn = e.target.closest(SELECTORS.tabBtn);
        if (!btn) return;

        const handle = btn.dataset.handle;

if (!isLikelyValidHandle(handle)) {
  showTabError(root, "This tab is misconfigured. Please try another.");
  return;
}

        if (!handle || btn.classList.contains("is-active")) return;

        root.classList.add("is-loading");
        try {
          await swapCollection(handle, { pushUrl: true });
          setActiveTab(root, handle);
        } catch (err) {
          console.error("[tabs] swap error", err);
          showTabError(root, "This collection is not available. Please choose another.");
        } finally {
          root.classList.remove("is-loading");
        }
      });

      window.addEventListener("popstate", async () => {
        const handle = getHandleFromPath(window.location.pathname);
        if (!handle) return;

        root.classList.add("is-loading");
        try {
          await swapCollection(handle, { pushUrl: false });
          setActiveTab(root, handle);
        } catch (err) {
          console.error("[tabs] popstate swap error", err);
        } finally {
          root.classList.remove("is-loading");
        }
      });
    } catch (err) {
      console.error("[tabs] init failed", err);
    }
  }

  document.addEventListener("DOMContentLoaded", init);
})();
